var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.958 16.654c0 .096-.03.183-.055.272-1.392-1.327-5.565-5.281-8.262-7.596 2.706-2.459 6.878-6.273 8.259-7.536.028.093.058.186.058.288v14.572zm-1.041 1.041H2.083c-.083 0-.157-.029-.235-.047 1.438-1.37 5.64-5.347 8.289-7.612.345.313.66.598.91.822.429.388.931.592 1.453.592s1.024-.204 1.453-.591l.91-.823c2.65 2.264 6.85 6.241 8.289 7.612-.078.018-.152.047-.235.047zm-21.875-1.04V2.081c0-.102.03-.195.058-.288A3509.21 3509.21 0 009.36 9.33c-2.698 2.315-6.872 6.27-8.263 7.596-.025-.089-.055-.176-.055-.272zM2.083 1.04h20.834c.076 0 .144.028.216.043-1.804 1.65-7.784 7.117-9.877 9.002-.164.147-.428.323-.756.323s-.592-.176-.756-.324a2739.635 2739.635 0 01-9.877-9c.072-.016.14-.044.216-.044zM22.917 0H2.083A2.085 2.085 0 000 2.081v14.572c0 1.149.934 2.082 2.083 2.082h20.834A2.084 2.084 0 0025 16.654V2.082A2.084 2.084 0 0022.917 0z",
    fill: "#8B9196",
    mask: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon_email.06aceb6a4663c3d65a0fa4e7a30602ae.svg";
export { ForwardRef as ReactComponent };